module.exports = __webpack_public_path__ + "static/img/nume__ro-6.842ca29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nume__ro-6.jpg
// module id = VpXi
// module chunks = 0